// src/lib/kinema/core/tools/PanTool.ts
import type { Tool, EditorPointerEvent, HitResult, ViewportProvider, Point } from './types';

export class PanTool implements Tool {
  name = 'pan';
  private isPanning = false;
  private lastPoint: Point | null = null;

  constructor(private viewport: ViewportProvider) {}

  onPointerDown(event: EditorPointerEvent, _hit: HitResult): void {
    this.isPanning = true;
    this.lastPoint = event.screenPoint; // use screen coords — not affected by pan/zoom
  }

  onPointerMove(event: EditorPointerEvent): void {
    if (!this.isPanning || !this.lastPoint) return;
    const dx = event.screenPoint.x - this.lastPoint.x;
    const dy = event.screenPoint.y - this.lastPoint.y;
    const current = this.viewport.getOffset();
    this.viewport.setOffset(current.x + dx, current.y + dy);
    this.lastPoint = event.screenPoint;
  }

  onPointerUp(_event: EditorPointerEvent): void {
    this.isPanning = false;
    this.lastPoint = null;
  }
}
